// extracted by mini-css-extract-plugin
var _1 = "KWzDkzlAwZ5E1UnVW1u0";
var _2 = "XtwxDdqpsgni_FPt2gCZ";
var _3 = "rUTado6VMK9AXawDkZrV";
var _4 = "usEAZlwr1mZlBJTHSrXI";
var _5 = "w0vPhn4YmT9w0KfCbpWz";
export { _1 as "container", _2 as "controlIcon", _3 as "controlsOverlay", _4 as "photoIcon", _5 as "photoPreview" }
